<template>
	<div style="width:1250px; height:830px;" v-on:keyup.esc="close()">
		<div class="half_tbl_box">
			<div class="left_big_tbl" style="height:810px;">
				<table class="view_tbl2" border="0">
					<colgroup>
						<col style="width:140px;" />
						<col style="" />
						<col style="width:140px;" />
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Courier</th>
							<td>
								<label class="mgr_10"><input type="radio" value="U" v-model="shipment.courier_type" :disabled="label_exists" /> UPS</label>
								<!-- <label class="mgr_10"><input type="radio" value="F" v-model="shipment.courier_type" :disabled="true || label_exists" /> FedEx</label> -->
								<label class="mgr_10"><input type="radio" value="F" v-model="shipment.courier_type" :disabled="label_exists || user.company_id == 'minkhair'" @click="clickFedex()" /> FedEx</label>
								<select v-model="shipment.service_code" class="tbl_select ssm2_int" :disabled="shipment.courier_type == 'F' || label_exists">
									<option value="01">Next Day Air</option>
									<option value="02">2nd Day Air</option>
									<option value="03">Ground</option>
								</select>
								<!-- {{ shipment.courier_type }} -->
							</td>
							<th>API Total <span v-if="user.company_id != 'beautyplus' && user.company_id != 'hairplus'"> / N. </span>Charge</th>
							<td>
								<currency-input type="text" v-model.trim="shipment.total_charge" class="tbl_int al_right ssm_int" readonly @focus="$event.target.select()" />
								<currency-input v-if="user.company_id != 'beautyplus' && user.company_id != 'hairplus'" type="text" v-model.trim="shipment.nego_charge" class="tbl_int al_right ssm_int" readonly @focus="$event.target.select()" />
							</td>
							<!-- <th>Tracking #</th>
					<td><input type="text" v-model.trim="shipment.track_no" class="tbl_int" readonly @focus="$event.target.select()" /></td> -->
						</tr>
						<tr v-if="!view_only">
							<th>Est. Rate. : UPS / Fedex</th>
							<td>
								<currency-input type="text" v-model.trim="shipment.ups_estimated_rating" class="tbl_int al_right sssm_int" readonly @focus="$event.target.select()" />
								/
								<currency-input type="text" v-model.trim="shipment.fedex_estimated_rating" class="tbl_int al_right sssm_int" readonly @focus="$event.target.select()" />
								<input
									v-if="user.company_id != 'beautyplus' && user.company_id != 'hairplus' && (shipment.ups_estimated_rating > 0 || shipment.fedex_estimated_rating > 0)"
									type="button"
									value="Update Inv. Freight Charge"
									class="gray_bt2"
									@click="applyToInvoice()"
									style="margin-left:5px;"
								/>
							</td>
							<!-- <th>FedEx Est. Rating</th>
							<td><currency-input type="text" v-model.trim="shipment.fedex_estimated_rating" class="tbl_int al_right ssm_int" readonly @focus="$event.target.select()" /></td> -->
							<th>SO Total / Invoice Amt.</th>
							<td>
								<currency-input type="text" v-model.trim="invoice.total_shipped_amount" class="tbl_int al_right ssm_int" readonly @focus="$event.target.select()" />
								<currency-input type="text" v-model.trim="invoice.invoice_amount" class="tbl_int al_right ssm_int" style="font-weight:bold;" readonly @focus="$event.target.select()" />
							</td>
						</tr>
						<tr>
							<th>Ship To / Phone</th>
							<td colspan="3">
								<input type="text" v-model.trim="shipment.ship_to_name" class="tbl_int quarter4_int" @focus="$event.target.select()" placeholder="Ship To Name" />
								<input type="text" v-model.trim="shipment.telephone" class="tbl_int auto_int" @focus="$event.target.select()" placeholder="Telephone" />
							</td>
							<!-- <th>Telephone</th>
        <td><input type="text" v-model.trim="shipment.telephone" class="tbl_int" @focus="$event.target.select()" /></td> -->
						</tr>
						<tr>
							<th rowspan="2">Address</th>
							<td colspan="3">
								<input type="text" v-model.trim="shipment.address_detail" class="tbl_int quarter4_int" @focus="$event.target.select()" placeholder="Address Line 1" />
								<input type="text" v-model.trim="shipment.address_city" class="tbl_int auto_int" @focus="$event.target.select()" placeholder="City or Town" />
								<input type="text" v-model.trim="shipment.address_detail2" class="tbl_int quarter4_int" @focus="$event.target.select()" placeholder="Address Line 2 (Optional)" />
							</td>
						</tr>
						<tr>
							<td colspan="3">
								<input type="text" v-model.trim="shipment.address_state" class="tbl_int ssm2_int" @focus="$event.target.select()" placeholder="State or Province" />
								<input type="text" v-model.trim="shipment.address_zipcode" class="tbl_int ssm_int" @focus="$event.target.select()" placeholder="Postal Code" />
								<span class="int_type_no_border">
									<CodeSelect :width="80" :descWidth="120" :showDesc="true" :codes="countries" v-model.trim="shipment.address_country" />
								</span>
							</td>
						</tr>
						<tr>
							<th>Bill Transportation To <br />Account No. / Address</th>
							<td colspan="3">
								<select v-model="bill_transportation_to.type" class="tbl_select ssm3_int" :disabled="service_type == 'F'" @change="billChanged()">
									<option value="S">Shipper</option>
									<option value="R">Receiver</option>
									<option value="T">Third Party</option>
								</select>

								<input
									type="text"
									v-model.trim="bill_transportation_to.account_number"
									class="tbl_int sm_int mgr_15"
									:disabled="bill_transportation_to.type == 'S'"
									@focus="$event.target.select()"
									placeholder="Receiver / 3rd Party Acc. No"
								/>
								3rd Party<input type="text" v-model.trim="bill_transportation_to.postal_code" class="tbl_int ssm_int" :disabled="bill_transportation_to.type == 'S'" @focus="$event.target.select()" placeholder="Postal Code" />
								/
								<input type="text" v-model.trim="bill_transportation_to.country_code" class="tbl_int ssm_int" :disabled="bill_transportation_to.type == 'S'" @focus="$event.target.select()" placeholder="Country Code" />
							</td>
						</tr>
						<!-- <tr>
					<th>Country</th>
					<td>
						<span class="int_type_no_border">
							<CodeSelect :width="80" :descWidth="120" :showDesc="true" :codes="countries" v-model.trim="shipment.address_country" />
						</span>
					</td>
					<th>Postal Code</th>
					<td><input type="text" v-model.trim="shipment.address_zipcode" class="tbl_int" @focus="$event.target.select()" /></td>
				</tr>
				<tr>
					<th>City or Town</th>
					<td><input type="text" v-model.trim="shipment.address_city" class="tbl_int" @focus="$event.target.select()" /></td>
					<th>State or Province</th>
					<td><input type="text" v-model.trim="shipment.address_state" class="tbl_int" @focus="$event.target.select()" /></td>
				</tr> -->
						<tr>
							<th>Options</th>
							<td colspan="3">
								<label for="cod" style="margin-left:5px;"> <input type="checkbox" id="cod" v-model="options.cod" :disabled="shipment.courier_type == 'F'" />COD</label>
								<label for="cod_fund_code" style="margin-left:15px;">
									<input type="checkbox" id="cod_fund_code" :disabled="!options.cod" v-model="options.cod_fund_code" :true-value="'8'" :false-value="'0'" />Cashier's Check / Money Order Only</label
								>
								<label for="declared_value" style="margin-left:15px;"> <input type="checkbox" id="declared_value" v-model="options.declared_value" />Declared Value</label>
								<select v-model="options.declared_value_code" class="tbl_select ssm3_int" :disabled="!options.declared_value">
									<option value="01">EVS</option>
									<option value="02">DVS</option>
								</select>
								<!-- <label for="declared_value_code" style="margin-left:15px;">
									<input type="checkbox" id="cod_fund_code" :disabled="!options.cod" v-model="options.cod_fund_code" :true-value="'8'" :false-value="'0'" />Cashier's Check / Money Order Only</label
								> -->
							</td>
						</tr>
						<tr>
							<th>Reference No 1 / 2</th>
							<td colspan="3">
								<input type="text" v-model.trim="shipment.reference_no_1" class="tbl_int sm_int" @focus="$event.target.select()" placeholder="Reference No 1" />
								<input type="text" v-model.trim="shipment.reference_no_2" class="tbl_int sm_int" @focus="$event.target.select()" placeholder="Reference No 2" />
								<input type="button" value="Load Default" class="gray_bt2" @click="loadDefaultReferenceNos()" style="margin-left:5px;" />
							</td>
						</tr>
						<tr v-if="service_type == 'G'">
							<th>Box(w/ Qty) Count</th>
							<td>
								<currency-input type="text" v-model="shipment.box_count" :precision="0" class="tbl_int sssm_int al_right" readonly />
								, <b>Total Weight</b>
								<currency-input type="text" v-model="shipment.total_weight" :precision="0" class="tbl_int sssm_int al_right" readonly />
							</td>
							<td colspan="2">
								<template v-if="partner.email_address">
									<label for="email" style="margin-left:5px;"> <input type="checkbox" id="email" v-model="options.email" />Email</label>
									<input type="text" :title="partner.email_address" v-model.trim="partner.email_address" class="tbl_int mm_int" disabled />
								</template>
							</td>
							<!-- <th>Total Weight</th>
							<td><currency-input type="text" v-model="invoice.total_weight" :precision="0" class="tbl_int sssm_int al_right" readonly /></td> -->
						</tr>
						<tr v-if="service_type == 'G'">
							<td colspan="4" valign="top">
								<h4 class="inner_h5">
									Box Detail
									<template v-if="user.company_id != 'minkhair'">
										<input type="button" value="Load From Packing Box " class="gray_bt2" @click="initialize()" style="margin-top:-3px;" />
										<input type="button" v-if="options.cod && boxes.length > 1" value="Spread COD Amount" class="gray_bt2" @click="spreadCODAmount()" style="margin-top:-3px;margin-left:15px;" />
									</template>
									<template v-else>
										<input type="button" value="Add" class="gray_bt2" @click="addBox()" style="margin-top:-3px;" />
									</template>
								</h4>
								<div class="fixed-table-common" style="height:450px;" ref="div_wrapper_parent">
									<div class="table-wrapper" ref="div_wrapper">
										<table class="list_tbl tbl_pointer">
											<!-- <table class="list_tbl"> -->
											<thead>
												<tr>
													<th style="text-align:center;width:35px;"><div class="th-text">No</div></th>
													<th style="text-align:center;width:55px;"><div class="th-text">Qty</div></th>
													<th v-if="user.company_id == 'hairplus'" style="text-align:center;width:80px;"><div class="th-text">Amount</div></th>
													<th style="text-align:center;width:65px;"><div class="th-text">WT (LB)</div></th>
													<th style="text-align:center;width:50px;"><div class="th-text">L (IN)</div></th>
													<th style="text-align:center;width:50px;"><div class="th-text">W (IN)</div></th>
													<th style="text-align:center;width:50px;"><div class="th-text">H (IN)</div></th>
													<th style="text-align:center;width:75px;"><div class="th-text">FRT ($)</div></th>
													<th style="text-align:center;width:100px;"><div class="th-text">COD Amt.</div></th>
													<th style="text-align:center;width:90px;"><div class="th-text">Decl. Value</div></th>
													<th style="text-align:center;"><div class="th-text">Category</div></th>
													<th style="text-align:center;width:50px;"><div class="th-text">HM/DG</div></th>
													<th v-if="user.company_id == 'minkhair'" style="text-align:center;width:50px;"><div class="th-text">Del</div></th>
													<!-- <th style="text-align:center;width:35%;"><div class="th-text">Creation DateTime</div></th> -->
												</tr>
											</thead>
											<tbody>
												<tr v-for="(box, index) in boxes" v-bind:key="index">
													<td class="al_right">{{ index + 1 }}</td>
													<td class="al_right"><currency-input type="text" v-model.trim="box.quantity" :precision="0" class="tbl_int full_int al_right" :readonly="user.company_id != 'minkhair'" @focus="$event.target.select()" /></td>
													<td v-if="user.company_id == 'hairplus'"><currency-input type="text" v-model.trim="box.amount" :precision="2" class="tbl_int full_int al_right" readonly /></td>
													<td class="al_right">
														<currency-input
															type="text"
															ref="weight"
															@keydown.down.prevent="keyDown('weight', index)"
															@keydown.up.prevent="keyUp('weight', index)"
															v-model.trim="box.weight"
															:precision="2"
															class="tbl_int full_int al_right"
															:readonly="user.company_id != 'minkhair'"
															@focus="$event.target.select()"
														/>
													</td>
													<td class="al_right"><currency-input type="text" v-model.trim="box.length" :precision="0" class="tbl_int full_int al_right" :readonly="user.company_id != 'minkhair'" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="box.width" :precision="0" class="tbl_int full_int al_right" :readonly="user.company_id != 'minkhair'" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="box.height" :precision="0" class="tbl_int full_int al_right" :readonly="user.company_id != 'minkhair'" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="box.freight" :precision="2" class="tbl_int full_int al_right" :readonly="user.company_id != 'minkhair'" @focus="$event.target.select()" /></td>
													<td class="al_right">
														<input type="checkbox" v-model="box.cod_apply" :true-value="true" :false-value="false" />
														<currency-input type="text" :disabled="!options.cod" v-model.trim="box.cod_amount" class="tbl_int al_right" style="width:70px;" @focus="$event.target.select()" />
													</td>
													<td class="al_right">
														<currency-input
															type="text"
															:disabled="!options.declared_value"
															v-model.trim="box.declared_value"
															:style="user.company_id == 'hairplus' ? 'color:red;' : ''"
															class="tbl_int al_right full_int"
															@focus="$event.target.select()"
														/>
													</td>
													<td class="al_center">
														<select v-model="box.category" class="tbl_select full_int">
															<option :value="null"></option>
															<option value="Hair">Hair</option>
															<option value="Brochures">Brochures</option>
															<option value="Magazines">Magazines</option>
															<option value="Mannequins">Mannequins</option>
														</select>
													</td>
													<td class="al_center"><input type="checkbox" v-model="box.hm_dg" :true-value="true" :false-value="false" /></td>
													<td v-if="user.company_id == 'minkhair'"><a href="javascript:;" type="button" class="gray_bt2" @click="delBox(index)">Del</a></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="service_type == 'F'">
							<td colspan="4" valign="top">
								<h4 class="inner_h5">
									Commodity
									<!-- <input type="text" v-model="weights.length" class="tbl_int sss2m_int al_right" readonly disabled />
            <input type="text" v-model="weightSum" class="tbl_int sss2m_int al_right" readonly disabled /> -->
									<input type="button" value="Add" class="gray_bt2" @click="addCommodity()" style="margin-top:-3px;" />
								</h4>
								<div class="fixed-table-common" style="height:250px;">
									<div class="table-wrapper">
										<table class="list_tbl tbl_pointer">
											<thead>
												<tr>
													<th style="text-align:center;width:5%;"><div class="th-text">No</div></th>
													<th style="text-align:center;width:15%;"><div class="th-text">Description</div></th>
													<th style="text-align:center;width:15%;"><div class="th-text">Type</div></th>
													<th style="text-align:center;width:10%;"><div class="th-text">Pieces</div></th>
													<th style="text-align:center;width:15%;"><div class="th-text">Weight(lb)</div></th>
													<th style="text-align:center;width:15%;"><div class="th-text">COD Amt</div></th>
													<th style="text-align:center;width:15%;"><div class="th-text">Category</div></th>
													<th style="text-align:center;width:10%;"><div class="th-text">HM/DG</div></th>
													<th style="text-align:center;width:5%;"><div class="th-text">Del</div></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(commodity, index) in commodities" v-bind:key="index">
													<td class="al_right">{{ index + 1 }}</td>
													<td class="al_left"><input type="text" v-model.trim="commodity.description" class="tbl_int full_int al_left" @focus="$event.target.select()" /></td>
													<td class="al_left">
														<!-- <input type="text" v-model.trim="commodity.packaging_type" class="tbl_int full_int al_left" @focus="$event.target.select()" /> -->
														<select v-model="commodity.packaging_type" class="tbl_select">
															<option v-for="packagingType in $packagingTypes" v-bind:value="packagingType.code" v-bind:key="packagingType.code">{{ packagingType.name }}</option>
														</select>
													</td>
													<td class="al_right"><currency-input type="text" v-model.trim="commodity.pieces" :precision="0" class="tbl_int full_int al_right" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="commodity.total_weight" :precision="2" :valueRange="{ min: 0, max: 9999 }" class="tbl_int full_int al_right" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" :disabled="!options.cod" v-model.trim="commodity.cod_amount" class="tbl_int al_right full_int" @focus="$event.target.select()" /></td>
													<td class="al_center">
														<select v-model="commodity.category" class="tbl_select ssm2_int">
															<option :value="null"></option>
															<option value="Hair">Hair</option>
															<option value="Brochures">Brochures</option>
															<option value="Magazines">Magazines</option>
															<option value="Mannequins">Mannequins</option>
														</select>
													</td>
													<td class="al_center"><input type="checkbox" v-model="commodity.hm_dg" :true-value="true" :false-value="false" /></td>
													<td><a href="javascript:;" type="button" class="gray_bt2" @click="delCommodity(index)">Del</a></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</td>
						</tr>
						<tr v-if="service_type == 'F'">
							<td colspan="4" valign="top">
								<h4 class="inner_h5">
									Handling Unit
									<!-- <input type="text" v-model="weights.length" class="tbl_int sss2m_int al_right" readonly disabled />
            <input type="text" v-model="weightSum" class="tbl_int sss2m_int al_right" readonly disabled /> -->
									<input type="button" value="Add" class="gray_bt2" @click="addHandlingUnit()" style="margin-top:-3px;" />
								</h4>
								<div class="fixed-table-common" style="height:250px;">
									<div class="table-wrapper">
										<table class="list_tbl tbl_pointer">
											<thead>
												<tr>
													<th style="text-align:center;width:5%;"><div class="th-text">No</div></th>
													<th style="text-align:center;width:30%;"><div class="th-text">Description</div></th>
													<th style="text-align:center;width:17%;"><div class="th-text">Type</div></th>
													<th style="text-align:center;width:10%;"><div class="th-text">Units</div></th>
													<th style="text-align:center;width:11%;"><div class="th-text">L(in)</div></th>
													<th style="text-align:center;width:11%;"><div class="th-text">W(in)</div></th>
													<th style="text-align:center;width:11%;"><div class="th-text">H(in)</div></th>
													<th style="text-align:center;width:5%;"><div class="th-text">Del</div></th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(unit, index) in handling_units" v-bind:key="index">
													<td class="al_right">{{ index + 1 }}</td>
													<td class="al_left"><input type="text" v-model.trim="unit.description" class="tbl_int full_int al_left" @focus="$event.target.select()" /></td>
													<td class="al_left">
														<!-- <input type="text" v-model.trim="commodity.packaging_type" class="tbl_int full_int al_left" @focus="$event.target.select()" /> -->
														<select v-model="unit.handling_unit_type" class="tbl_select">
															<option v-for="unitType in $handlingUnitTypes" v-bind:value="unitType.code" v-bind:key="unitType.code">{{ unitType.name }}</option>
														</select>
													</td>
													<td class="al_right"><currency-input type="text" v-model.trim="unit.units" :precision="0" class="tbl_int full_int al_right" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="unit.length" :precision="2" class="tbl_int full_int al_right" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="unit.width" :precision="2" class="tbl_int full_int al_right" @focus="$event.target.select()" /></td>
													<td class="al_right"><currency-input type="text" v-model.trim="unit.height" :precision="2" class="tbl_int full_int al_right" @focus="$event.target.select()" /></td>
													<td><a href="javascript:;" type="button" class="gray_bt2" @click="delHandlingUnit(index)">Del</a></td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>

				<div class="view_bottom_bt" style="padding-top:10px;">
					<!-- <a href="javascript:;" type="button" class="search_bt mgr_15 mgr_15" @click="zplPrintTest()">ZPL Test</a> -->
					<a v-if="isBeautyplus && fedexAccountChanged" href="javascript:void(0)" class="gray_bt mgr_15" type="button" @click="printFedexAcctChangeLabel()">Fedex ShipTo(s)</a>
					<select v-if="!label_exists" v-model="label_type" class="tbl_select" style="width:55px;">
						<option value="ZPL">ZPL</option>
						<option value="PNG">PNG</option>
					</select>
					<a v-if="!label_exists && shipment.jobid" href="javascript:;" type="button" class="search_bt mgr_15 mgr_10" @click="checkAsyncProcess()">Check Process</a>
					<a v-else-if="!label_exists && !view_only" href="javascript:;" type="button" class="search_bt mgr_15 mgr_10" @click="processShipment()">Process</a>
					<!-- <a v-else-if="!view_only && label_exists && (user.company_id != 'newjigu' || invoice_modifiable)" href="javascript:;" type="button" style="float:left;" class="search_bt mgr_15 mgr_10" @click="voidShipment()">Void</a> -->
					<a v-else-if="!view_only && label_exists && invoice_modifiable" href="javascript:;" type="button" style="float:left;" class="search_bt mgr_15 mgr_10" @click="voidShipment()">Void</a>

					<a v-if="!view_only && !label_exists" href="javascript:;" type="button" class="gray_bt mgr_10" @click="estimateAll()">Rate EST.</a>
					<a href="javascript:;" type="button" class="gray_bt mgr_10" @click="shipmentHistory()">History</a>
					<a href="javascript:;" type="button" class="gray_bt mgr_10" @click="json()">JSON</a>
					<a v-if="!label_exists && !view_only" href="javascript:;" type="button" class="search_bt" @click="save()">Save</a>
					<a v-if="label_exists && shipment.courier_type == 'U'" href="javascript:void(0)" class="gray_bt mgr_15" type="button" @click="upsLabelPrint()">Label Print</a>
					<a v-if="label_exists && shipment.courier_type == 'F'" href="javascript:void(0)" class="gray_bt mgr_15" type="button" @click="fedexLabelPrint()">Label Print</a>

					<a href="javascript:;" type="button" class="gray_bt" @click="close()">Close</a>
				</div>
			</div>
			<div class="right_small_tbl">
				<h4 class="inner_h5">
					Label(s)
					<span v-if="shipment.void_track_no"
						>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Prev. Void Track No : <a :href="'https://ups.com/track?loc=null&tracknum=' + shipment.void_track_no + '&requester=WT/trackdetails'" target="_blank">{{ shipment.void_track_no }} </a></span
					>
				</h4>
				<table class="view_tbl">
					<colgroup>
						<col style="width:100px;" />
						<!-- <col style="width:200px;" /> -->
						<col style="" />
					</colgroup>
					<tbody>
						<tr v-if="shipmentBoxes.length > 0">
							<td colspan="2">
								<span v-if="shipmentBoxes[0].label_image_type.startsWith('ZPL')" style="font-weight:bold;">* Printable by ZPL printer using 'Generic/Text' driver</span>
								<!-- <span v-if="shipmentBoxes[0].label_image_type.startsWith('PNG')" style="font-weight:bold;">* Printable by general or laser printer</span> -->
							</td>
						</tr>
						<template v-for="box in shipmentBoxes">
							<tr v-bind:key="box.box_no + '1'">
								<th><font color="blue">Tracking No</font></th>
								<td>
									<a
										v-if="shipment.courier_type == 'U'"
										:href="'https://wwwapps.ups.com/WebTracking/processRequest?HTMLVersion=5.0&Requester=NES&AgreeToTermsAndConditions=yes&loc=en_US&tracknum=' + box.track_no + '&WT.z_eCTAid=ct1_eml_Tracking/trackdetails'"
										target="_blank"
										>{{ box.track_no }}</a
									>
									<a v-if="shipment.courier_type == 'F'" :href="'https://www.fedex.com/fedextrack/?trknbr=' + box.track_no" target="_blank">{{ box.track_no }}</a>
								</td>
							</tr>
							<tr v-bind:key="box.box_no + '2'">
								<td colspan="2" class="al_center">
									<template v-if="box.label_image_data && box.label_image_type.startsWith('PNG')">
										<img :width="shipment.courier_type == 'U' ? 355 : 310" v-bind:src="'data:image/' + box.label_image_type + ';base64,' + box.label_image_data" />
									</template>
								</td>
							</tr>
						</template>
					</tbody>
				</table>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ShipmentHistory'" :draggable="false">
			<template slot="title">Label Process History</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div style="width:650px; height:400px;" v-on:keyup.esc="close()">
					<table class="list_tbl">
						<thead>
							<tr>
								<th width="25%">Update Date Time</th>
								<th width="20%">Process Type</th>
								<th>User</th>
								<th width="40%">Track No</th>
								<!-- <th width="4%">Ship To</th>
								<th width="7%">Payment Term</th>
								<th width="7%">Ship Charge</th>
								<th width="7%">Delivery Type</th>
								<th width="5%">From Amt.</th>
								<th width="5%">To Amt.</th>								
								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<th width="8%">Picker</th>
									<th width="7%">Pickup Start</th>
									<th width="7%">Pickup End</th>
									<th width="8%">Packer</th>
									<th width="7%">Packed DT</th>
								</template>
								<th width="5%">View Items</th> -->
							</tr>
						</thead>
						<tbody>
							<tr v-for="history in histories" v-bind:key="history.invoice_shipment_history_no">
								<td class="al_left">{{ history.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
								<td class="al_left">{{ history.process_type }}</td>
								<td class="al_left">{{ history.crt_name }}</td>
								<td class="al_left">
									{{ history.track_no }}
									<a v-if="user.super_admin_yn == 'Y'" href="javascript:void(0)" class="gray_bt mgr_15" type="button" @click="voidShipmentFromHistory(history.track_no)">Void</a>
								</td>
								<!-- <td class="al_left">{{ history.payment_term_name }}</td>
								<td class="al_left">{{ history.ship_charge_name }}</td>
								<td class="al_left">{{ history.delivery_type_name }}</td>
								<td class="al_right">{{ history.status_code == 'I' ? history.from_invoice_amount : history.from_total_amount | toCurrency }}</td>
								<td class="al_right">{{ history.status_code == 'I' ? history.to_invoice_amount : history.to_total_amount | toCurrency }}</td>
								
								<template v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.picker_id != histories[index - 1].picker_id)">
											{{ history.picker_name }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.pickup_start_dt != histories[index - 1].pickup_start_dt)">
											{{ history.pickup_start_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.pickup_end_dt != histories[index - 1].pickup_end_dt)">
											{{ history.pickup_end_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.packed_user != histories[index - 1].packed_user)">
											{{ history.packer_name }}
										</template>
									</td>
									<td class="al_left">
										<template v-if="index == 0 || (index > 0 && history.packed_dt != histories[index - 1].packed_dt)">
											{{ history.packed_dt | moment('MM-DD HH:mm:ss') }}
										</template>
									</td>
								</template>
								<td class="al_left"><a href="javascript:;" @click="viewHistoryItems(history)" class="outstanading">View Items</a></td> -->
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Json'" :draggable="false">
			<template slot="title">JSON Request / Response</template>
			<template slot="body">
				<div style="width:600px; height:800px;">
					<div style="padding-top:5px;">
						Request<br />
						<textarea rows="24" cols="82" v-model="json_request_str"></textarea>
					</div>
					<div style="padding-top:5px;">
						Response <br />
						<textarea rows="24" cols="82" v-model="json_result_str"></textarea>
					</div>
				</div>
				<!-- <ShipmentPopup :invoice="invoice" v-on:close="closeModal()" /> -->
			</template>
		</Modal>
	</div>
</template>

<script>
import { apiEstimateRating, apiProcessShipment, apiCheckAsyncProcess, apiSelectInvoiceShipment, apiUpdateInvoiceShipment, apiVoidShipment, apiInsertShipmentLabelPrintHistory, apiSelectInvoiceShipmentHistory } from '@/api/sales/invoice.js';
import CodeSelect from '@/components/common/CodeSelect';
import _ from 'lodash';
import { apiGetBase64ReportTemplate, apiGetReportTemplate, Report, reportMrtUrl } from '@/api/util';
import { zplPrint } from '@/utils/etc.js';
import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			shipment: { courier_type: 'U', service_code: '03' },
			histories: [],
			shipmentBoxes: [],
			boxes: [],
			packing_boxes: [],
			deliveryChangeMessage: null,
			shipToChangeMessage: null,

			partner: {},

			commodities: [],
			handling_units: [],
			bill_transportation_to: { type: 'S' },

			options: { cod: false, cod_fund_code: '0', declared_value: false, declared_value_code: '01' },

			countries: [],

			service_type: null, // G : Ground,일반 택배 인 듯, F : 화물

			json_request: {},
			json_result: {},

			label_exists: false,

			showModal: false,
			modalName: null,
			additionalInvoices: [],

			label_type: 'PNG',
		};
	},
	props: {
		invoice_no: Number,
		invoice: Object,
		view_only: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company: function() {
			return this.$session.get('company');
		},
		isBeautyplus() {
			return this.user && this.user.company_id === 'beautyplus';
		},
		json_request_str: function() {
			return JSON.stringify(this.json_request, null, 2);
		},
		json_result_str: function() {
			return JSON.stringify(this.json_result, null, 2);
		},
		printData: function() {
			return { image: this.shipmentBoxes, msg: this.deliveryChangeMessage, shipToChangeMessage: this.shipToChangeMessage, additionalInvoices: this.additionalInvoices, shipment: this.shipment, partner: this.partner };
		},
		env: function() {
			return process.env.NODE_ENV;
		},
		invoice_modifiable() {
			if (this.user.admin_yn == 'Y') return true;
			else if (this.user.company_id != 'newjigu' && this.user.company_id != 'beautyplus') return true;
			else if (this.user.company_id == 'beautyplus' && this.user.user_type == 'salesman') return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if (menus[i].path == '/sales/invoice_main' && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		fedexAccountChanged() {
			return (this.invoice.delivery_type_name ? this.invoice.delivery_type_name.toUpperCase() : '').indexOf('FEDEX') > -1 && this.shipToChangeMessage;
		},
	},
	watch: {
		boxes: {
			deep: true,
			handler: function() {
				this.shipment.box_count = this.boxes.filter(b => b.quantity > 0).length;
				var total_weight = 0;
				this.boxes.forEach(b => {
					if (b.weight > 0) total_weight += b.weight;
				});
				if (total_weight > 0) this.shipment.total_weight = total_weight;
			},
		},
	},
	components: {
		//CustomDatePicker,
		CodeSelect,
		Modal,
	},
	methods: {
		spreadCODAmount() {
			var filterd_boxes = this.boxes.filter(b => b.cod_apply);
			if (filterd_boxes.length == 0) return;

			const each_cod_amount = Math.round((Number.EPSILON + this.invoice.balance / filterd_boxes.length) * 100) / 100;
			var box_cod_total = each_cod_amount * filterd_boxes.length;
			filterd_boxes.forEach(b => {
				b.cod_amount = each_cod_amount;
			});

			const residual = this.invoice.balance - box_cod_total;

			if (residual < 0) filterd_boxes[filterd_boxes.length - 1].cod_amount += residual;
			else filterd_boxes[0].cod_amount += residual;

			this.boxes
				.filter(b => !b.cod_apply)
				.forEach(b => {
					b.cod_amount = null;
				});

			//console.log('test');
			this.$forceUpdate();
			//if (this.user.company_id == 'beautyplus') this.boxes[this.getMostExpensiveBoxIndex(false)].cod_amount = this.invoice.balance;
			//else if (this.user.company_id == 'hairplus') this.boxes[this.getMostExpensiveBoxIndex(true)].cod_amount = this.invoice.balance;
			//else this.boxes[0].cod_amount = this.invoice.balance;
		},
		keyDown(ref, index) {
			if (index < this.boxes.length - 1) {
				this.$refs[ref][index + 1].$el.select();
				if (this.$refs[ref][index + 1].$el.offsetParent.offsetTop + 2 * this.$refs[ref][index + 1].$el.offsetParent.scrollHeight > this.$refs.div_wrapper_parent.scrollHeight) {
					this.$refs.div_wrapper.scrollTop += this.$refs[ref][index + 1].$el.offsetParent.scrollHeight + 1;
				}
				//console.log(this.$refs.div_wrapper_parent.scrollHeight);
				//console.log(this.$refs.div_wrapper.scrollTop, this.$refs[ref][index + 1].$el.offsetParent.offsetTop, this.$refs[ref][index + 1].$el.offsetParent.scrollHeight);
			}
		},
		keyUp(ref, index) {
			if (index > 0) {
				this.$refs[ref][index - 1].$el.select();
				this.$refs.div_wrapper.scrollTop = this.$refs[ref][index - 1].$el.offsetParent.offsetTop;
			}
		},
		async reload() {
			//background에 있는 Invoice Detail에서 저장한 경우, reload함
			await this.selectInvoiceShipment();
			//if (this.options.cod) this.setCod();
		},
		applyToInvoice() {
			var charge_to_apply = null;
			if (this.shipment.courier_type == 'U' && this.shipment.ups_estimated_rating > 0) charge_to_apply = this.shipment.ups_estimated_rating;
			else if (this.shipment.courier_type == 'F' && this.shipment.fedex_estimated_rating > 0) charge_to_apply = this.shipment.fedex_estimated_rating;

			if (charge_to_apply > 0) {
				this.$emit('apply-invoice-freight-charge', charge_to_apply);
			} else {
				this.$toast.error('No charge to apply');
			}
		},
		zplPrintTest() {
			// 워터마크
			// 컬러 프린트가 아닌 경우, 색상(gray)를 구현할 수 없음.
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			const type = 'image/png';
			canvas.width = '480';
			canvas.height = '160';
			ctx.textBaseline = 'bottom';
			ctx.font = '160px serif';
			ctx.fillStyle = 'gray';
			ctx.fillText('W11', 0, 160);

			let watermark = canvas.toDataURL(type).replace('data:' + type + ';base64,', '');

			// 한글 출력을 위해서는 프린트에 UHANGUL.DAT, KFONT3.FNT 파일이 존재해야 함.
			var str = '^XA';
			str += '^FX Top section with logo, name and address.';
			// str += '^SEE:UHANGUL.DAT^FS';
			// str += '^CW1,E:KFONT3.FNT^CI26^FS';
			// str += '^CF1,60';
			str += '^CF0,60';
			str += '^FO50,50^GB100,100,100^FS';
			str += '^FO75,75^FR^GB100,100,100^FS';
			str += '^FO93,93^GB40,40,40^FS';
			str += '^FO220,50^FDIntershipping, Inc.^FS';
			str += '^CF0,30';
			str += '^FO220,115^FD1000 Shipping Lane^FS';
			str += '^FO220,155^FDShelbyville TN 38102^FS';
			str += '^FO220,195^FDUnited States (USA)^FS';
			str += '^FO50,250^GB700,3,3^FS';
			str += '^XZ';
			str += '~BI300,300,1,' + watermark;

			console.log(str);
			zplPrint(str);
		},
		clickFedex() {
			this.options.cod = false;
		},
		billChanged() {
			if (this.bill_transportation_to.type == 'T') this.options.declared_value_code = '02';
			else this.options.declared_value_code = '01';

			if (this.bill_transportation_to.type == 'S') this.bill_transportation_to.account_number = null;
			else this.bill_transportation_to.account_number = this.partner.ups_account_number;
		},
		json() {
			// if (!this.json_result.RateResponse) {
			// 	this.$toast.error('No JSON Data');
			// 	return;
			// }

			this.modalName = 'Json';
			this.showModal = true;

			//console.log(JSON.stringify(this.json_request, null, 2));
			//console.log(JSON.stringify(this.json_result, null, 2));
		},
		shipmentHistory() {
			this.modalName = 'ShipmentHistory';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		addBox() {
			this.boxes.push({ category: 'Hair' });
		},
		delBox(index) {
			this.boxes.splice(index, 1);
		},
		addCommodity() {
			this.commodities.push({ description: 'Hair Goods', packaging_type: 'PLT', pieces: 1 });
		},
		delCommodity(index) {
			this.commodities.splice(index, 1);
		},
		addHandlingUnit() {
			this.handling_units.push({ description: 'Hair Goods', handling_unit_type: 'PLT', units: 1 });
		},
		delHandlingUnit(index) {
			this.handling_units.splice(index, 1);
		},
		getTotalCodAmount() {
			var total_cod_amount = 0;
			this.boxes.forEach(b => {
				if (b.cod_amount > 0) total_cod_amount += b.cod_amount;
			});

			return total_cod_amount;
		},
		isValid(for_process) {
			var valid = true;
			// if (!(this.shipment.total_weight > 0)) {
			// 	this.$toast.error('Invalid weight. Check the weight(s) of the box(es)');
			// 	valid = false;
			// }

			if (!this.shipment.ship_to_name) {
				this.$toast.error('Empty ship to name');
				valid = false;
			}

			// if (this.shipment.ship_to_name.length > 35) {
			// 	this.$toast.warning('Ship To Name exceeds 35 length. Excessive words will be truncated.');
			// }

			if (!this.shipment.telephone) {
				this.$toast.error('Empty Phone Number');
				valid = false;
			}

			if (!this.shipment.address_country) {
				//this.$toast.error('Empty country');
				//valid = false;
				this.shipment.address_country = 'US';
			}

			if (!this.shipment.address_zipcode) {
				this.$toast.error('Empty zipcode');
				valid = false;
			}

			if (!this.shipment.address_city) {
				this.$toast.error('Empty city');
				valid = false;
			}

			if (!this.shipment.address_state) {
				this.$toast.error('Empty state');
				valid = false;
			}

			if (this.service_type == 'F' && this.commodities.length == 0) {
				this.$toast.error('Empty commodity');
				valid = false;
			} else if (this.service_type == 'G') {
				if (this.user.company_id == 'beautyplus' && this.boxes.filter(b => !(b.weight > 0)).length > 0) {
					this.$toast.error('Box with no weight exists');
					valid = false;
				} else if (!this.shipment.total_weight > 0) {
					this.$toast.error('Invalid total weight');
					valid = false;
				}
			}

			if (this.service_type == 'G' && this.boxes.length == 0) {
				this.$toast.error('No Box Information');
				valid = false;
			}

			if (this.commodities.filter(c => !c.description || !c.pieces || !c.total_weight).length > 0) {
				this.$toast.error('Invalid value in commodities');
				valid = false;
			}

			if (this.options.cod) {
				var total_cod_amount = this.getTotalCodAmount();
				if (total_cod_amount == 0) {
					this.$toast.error('Invalid COD Amount');
					valid = false;
				}

				if (for_process && total_cod_amount != this.invoice.balance) {
					alert('COD Amount( ' + total_cod_amount + ' ) does not match Invoice Amount/Balance ( ' + this.invoice.balance + ' ) \n\nYou can choose "Cancel" in the next popup window.');
				}
			}

			return valid;
		},
		async checkAsyncProcess() {
			//console.log(this.shipment);
			var request = {
				accountNumber: {
					value: this.company.fedex_account_number,
				},
				jobId: this.shipment.jobid,
				//shipAction: 'CONFIRM',
			};

			this.shipment.json_string = JSON.stringify(request);
			const { data } = await apiCheckAsyncProcess(this.shipment);

			if (data.result) {
				//console.log(data);
				this.json_result = JSON.parse(data.json_result);
				this.$toast.success('Shipment processed successfully', { duration: 1000, pauseOnHover: false });
				this.selectInvoiceShipment();
				this.$emit('set-shipment-exists', true);
			} else {
				this.$toast.error(data.msg, { duration: 10000 });
			}
		},
		async processShipment() {
			if (await this.checkLabelExists()) {
				alert('Label exists. Close this popup window and reload invoice.');
				return;
			}

			if (!this.isValid(true)) return;

			this.save();

			var msg = 'Proceed?';

			this.$alertify.confirm('Are you sure to process shipment?', () => {
				if (this.invoice.payment_term_name) {
					if (this.invoice.payment_term_name.toUpperCase().indexOf('CREDIT CARD') >= 0) {
						msg = 'Credit Card Pay!!! ' + msg;
						this.processShipmentCheckMore(msg);
					} else if (this.invoice.payment_term_name.toUpperCase().indexOf('PREPAID') >= 0) {
						msg = 'Prepaid!!! ' + msg;
						this.processShipmentCheckMore(msg);
					} else if (this.invoice.payment_term_name.toUpperCase().indexOf('COD M/O') >= 0) {
						msg = this.invoice.payment_term_name + '!!! ' + msg;
						this.processShipmentCheckMore(msg);
					} else {
						this.processShipmentConfirm();
					}
					// if (this.invoice.payment_term_name.toUpperCase().indexOf('CREDIT CARD') >= 0) {
					// 	this.$alertify.alert('Alert', 'Credit Card Pay');
					// } else if (this.invoice.payment_term_name.toUpperCase().indexOf('PREPAID') >= 0) {
					// 	this.$alertify.alert('Alert', 'Prepaid');
					// } else if (this.invoice.payment_term_name.toUpperCase().startsWith('COD M/O')) {
					// 	this.$alertify.alert('Alert', this.invoice.payment_term_name);
					// } else {
					// 	this.processShipmentConfirm();
					// }
				} else {
					this.processShipmentConfirm();
				}
			});
		},

		processShipmentCheckMore(msg) {
			if (confirm(msg)) {
				this.processShipmentConfirm();
			}
		},

		async processShipmentConfirm() {
			// console.log('processed');
			// var dummy = true;
			// if (dummy) return;
			//console.log(this.invoice);

			this.shipment.json_content = this.makeJsonData();
			if (this.shipment.courier_type == 'U') this.shipment.json_string = this.makeUPSShipmentData();
			else if (this.shipment.courier_type == 'F') this.shipment.json_string = this.makeFedexShipmentData();

			// var dummy = true;
			// if (dummy) return;
			const { data } = await apiProcessShipment(this.shipment);

			if (data.result) {
				//console.log(data);
				this.json_result = JSON.parse(data.json_result);
				if (this.shipment.async) this.$alertify.alert('Alert', 'Requested successfully. Check process later');
				else this.$toast.success('Shipment processed successfully', { duration: 1000, pauseOnHover: false });
				this.selectInvoiceShipment();
				this.$emit('set-shipment-exists', true);
			} else {
				this.$toast.error(data.msg, { duration: 10000 });
			}
		},
		voidShipmentFromHistory(track_no) {
			this.$alertify.confirm('Are you sure?', () => {
				this.voidShipmentConfirmFromHistory(track_no);
			});
		},
		async voidShipmentConfirmFromHistory(track_no) {
			var shipment_temp = _.cloneDeep(this.shipment);
			if (shipment_temp.courier_type == 'U') {
				shipment_temp.shipment_identification_number = track_no;
			} else if (shipment_temp.courier_type == 'F') {
				var request = {
					accountNumber: {
						value: this.company.fedex_account_number,
					},
					deletionControl: 'DELETE_ALL_PACKAGES',
					trackingNumber: track_no,
				};

				shipment_temp.json_string = JSON.stringify(request);
			}

			shipment_temp.api_only = true; //API에서만 void 처리함
			const { data } = await apiVoidShipment(shipment_temp);
			//console.log(data);

			if (data.result) {
				this.$toast.success('Shipment made void successfully', { duration: 1000, pauseOnHover: false });
			} else {
				this.$toast.error(data.msg, { duration: 10000 });
			}
		},
		voidShipment() {
			this.$alertify.confirm('Are you sure to void shipment?', () => {
				this.voidShipmentConfirm();
			});
		},
		async voidShipmentConfirm() {
			if (this.shipment.courier_type == 'U') {
				this.shipment.shipment_identification_number = this.shipmentBoxes[0].track_no;
			} else if (this.shipment.courier_type == 'F') {
				var request = {
					accountNumber: {
						value: this.company.fedex_account_number,
					},
					deletionControl: 'DELETE_ALL_PACKAGES',
					trackingNumber: this.shipmentBoxes[0].track_no,
				};

				//console.log(JSON.stringify(request, null, 2));

				this.shipment.json_string = JSON.stringify(request);
			}
			const { data } = await apiVoidShipment(this.shipment);
			//console.log(data);

			if (data.result) {
				this.json_result = JSON.parse(data.json_result);
				this.$toast.success('Shipment made void successfully', { duration: 1000, pauseOnHover: false });
				this.selectInvoiceShipment();
				this.$emit('set-shipment-exists', false);
				//console.log(data.json_result);
			} else {
				//this.$toast.error(data.msg);
				//this.json_result = JSON.parse(data.json_result);
				this.$toast.error(data.msg, { duration: 10000 });
			}
		},
		async estimate(courier_type) {
			var param = _.cloneDeep(this.shipment);
			param.courier_type = courier_type;
			//console.log(courier_type, this.service_type);
			if (courier_type == 'U' && (this.service_type == 'G' || this.service_type == 'F')) {
				if (this.service_type == 'G') param.json_string = this.makeUPSRatingDataGround();
				else if (this.service_type == 'F') param.json_string = this.makeUPSRatingDataFreight();

				param.service_type = this.service_type;
				const { data } = await apiEstimateRating(param);

				if (data.result) {
					this.shipment.ups_estimated_rating = data.rating;
					if (data.json_result) {
						this.json_result = JSON.parse(data.json_result);
						//this.$toast.warning(data.alert);
						//var response = JSON.parse(data.response);
						//console.log(response);
						if (data.json_result.FreightRateResponse && data.json_result.FreightRateResponse.Response && data.json_result.FreightRateResponse.Response.Alert) {
							this.$toast.warning(JSON.stringify(data.json_result.FreightRateResponse.Response.Alert), { duration: 10000 });
						}
					}
				} else {
					this.$toast.error(data.msg, { duration: 10000 });
				}
			} else if (courier_type == 'F') {
				param.json_string = this.makeFedexRating();
				const { data } = await apiEstimateRating(param);
				//console.log(data);
				if (data.result) {
					this.shipment.fedex_estimated_rating = data.rating;
					if (data.json_result) {
						this.json_result = JSON.parse(data.json_result);
					}
				} else {
					this.$toast.error(data.msg);
				}
			}

			//else if (courier_type == 'F') this.shipment.fedex_estimated_rating = data.rating;

			//console.log(this.shipment);
			this.$forceUpdate();
		},
		async estimateAll() {
			if (!this.company.ups_shipper_number && !this.company.fedex_account_number) {
				this.$toast.error('Neither UPS Shippner Number nor Fedex Account Number are present.');
				return;
			}
			if (!this.isValid(false)) return;

			if (this.company.ups_shipper_number) this.estimate('U');

			//if (this.user.company_id != 'minkhair') this.estimate('F');
			if (this.company.fedex_account_number) this.estimate('F');
		},
		makeUPSRatingDataGround() {
			//Shipper
			var shipper = {
				Name: this.company.name,
				ShipperNumber: this.company.ups_shipper_number,
				Address: {
					AddressLine: this.company.ship_address_detail,
					City: this.company.ship_address_city,
					StateProvinceCode: this.company.ship_address_state,
					PostalCode: this.company.ship_address_zipcode,
					CountryCode: this.company.ship_address_country,
				},
			};

			if (!shipper.Address.CountryCode || shipper.Address.CountryCode == 'USA') shipper.Address.CountryCode = 'US';

			//Ship To
			var ship_to = {
				Name: this.shipment.ship_to_name,
				Address: {
					AddressLine: this.shipment.address_detail2 ? [this.shipment.address_detail.substring(0, 35), this.shipment.address_detail2.substring(0, 35)] : this.shipment.address_detail.substring(0, 35),
					City: this.shipment.address_city,
					StateProvinceCode: this.shipment.address_state,
					PostalCode: this.shipment.address_zipcode,
					CountryCode: this.shipment.address_country,
				},
			};

			if (!ship_to.Address.CountryCode || ship_to.Address.CountryCode == 'USA') ship_to.Address.CountryCode = 'US';

			var packages = [];

			this.boxes
				.filter(box => box.weight > 0)
				.forEach(b => {
					var box = {
						PackagingType: {
							Code: '00',
						},
						PackageWeight: {
							UnitOfMeasurement: { Code: 'LBS' },
							Weight: b.weight.toFixed(2),
						},
					};
					//console.log(b, b.length, b.width, b.height);

					if (b.length > 0 && b.width > 0 && b.height > 0)
						box.Dimensions = {
							UnitOfMeasurement: {
								Code: 'IN',
							},
							Length: b.length.toFixed(),
							Width: b.width.toFixed(),
							Height: b.height.toFixed(),
						};
					packages.push(box);
				});

			var ShipmentRatingOptions = {
				NegotiatedRatesIndicator: '',
			};

			//Request
			var rating_request = {
				Shipment: {
					Shipper: shipper,
					ShipTo: ship_to,
					ShipFrom: shipper,
					Service: {
						//Code: '03',
						Code: this.shipment.service_code,
					},
					ShipmentTotalWeight: {
						UnitOfMeasurement: { Code: 'LBS' },
						Weight: this.shipment.total_weight.toFixed(0),
					},
					Package: packages,
					DeliveryTimeInformation: {
						PackageBillType: '03',
					},
					ShipmentRatingOptions: ShipmentRatingOptions,
				},
			};

			var request = { RateRequest: rating_request };

			this.json_request = request;
			this.json_result = {};

			return JSON.stringify(request);
			//return JSON.stringify(rating_request);
		},
		makeFedexRating() {
			var packages = [];

			this.boxes
				.filter(box => box.weight > 0)
				.forEach(b => {
					var box = {
						weight: {
							units: 'LB',
							value: b.weight.toFixed(2),
						},
					};
					packages.push(box);
				});

			var request = {
				accountNumber: {
					value: this.company.fedex_account_number,
				},
				requestedShipment: {
					shipper: {
						address: {
							city: this.company.ship_address_city,
							stateOrProvinceCode: this.company.ship_address_state,
							postalCode: this.company.ship_address_zipcode,
							countryCode: this.company.ship_address_country,
						},
					},
					recipient: {
						address: {
							city: this.shipment.address_city,
							stateOrProvinceCode: this.shipment.address_state,
							postalCode: this.shipment.address_zipcode,
							countryCode: this.shipment.address_country,
						},
					},
					serviceType: 'FEDEX_GROUND',
					pickupType: 'USE_SCHEDULED_PICKUP',
					//pickupType: 'DROPOFF_AT_FEDEX_LOCATION',
					//rateRequestType: ['ACCOUNT', 'LIST'],
					rateRequestType: ['ACCOUNT'],
					requestedPackageLineItems: packages,
				},
			};

			if (!request.requestedShipment.shipper.address.countryCode || request.requestedShipment.shipper.address.countryCode == 'USA') request.requestedShipment.shipper.address.countryCode = 'US';
			if (!request.requestedShipment.recipient.address.countryCode || request.requestedShipment.recipient.address.countryCode == 'USA') request.requestedShipment.recipient.address.countryCode = 'US';

			//console.log(JSON.stringify(json, null, 2));

			this.json_request = request;
			this.json_result = {};

			return JSON.stringify(request);
		},
		makeUPSRatingDataFreight() {
			//Shipper
			var shipper = {
				Name: this.company.name,
				Address: {
					AddressLine: this.company.ship_address_detail,
					City: this.company.ship_address_city,
					StateProvinceCode: this.company.ship_address_state,
					PostalCode: this.company.ship_address_zipcode,
					CountryCode: this.company.ship_address_country,
				},
			};

			//Ship To
			var ship_to = {
				Name: this.shipment.ship_to_name,
				Address: {
					AddressLine: this.shipment.address_detail,
					City: this.shipment.address_city,
					StateProvinceCode: this.shipment.address_state,
					PostalCode: this.shipment.address_zipcode,
					CountryCode: this.shipment.address_country,
				},
			};

			//Payer
			var payment = {
				Payer: {
					Name: this.company.name,
					Address: {
						AddressLine: this.company.address_detail,
						City: this.company.address_city,
						StateProvinceCode: this.company.address_state,
						PostalCode: this.company.address_zipcode,
						CountryCode: this.company.ship_address_country,
					},
					ShipperNumber: this.company.ups_shipper_number,
				},
				ShipmentBillingOption: { Code: '10' },
			};
			//Service
			var service = { Code: '308' };

			var handling = {
				Quantity: '1',
				Type: { Code: 'PLT' },
			};

			//Commodity
			var commodities = [];

			this.commodities.forEach(c => {
				var com = {
					Description: c.description,
					Weight: {
						UnitOfMeasurement: { Code: 'LBS' },
						Value: c.total_weight.toFixed(2),
					},
					NumberOfPieces: c.pieces.toFixed(0),
					PackagingType: { Code: c.packaging_type },
					FreightClass: '50',
				};
				commodities.push(com);
			});

			//Handling Unnis
			var handlingUnits = [];
			this.handling_units.forEach(u => {
				var hu = {
					Quantity: '1',
					Type: { Code: u.handling_unit_type },
					Dimensions: {
						UnitOfMeasurement: { Code: 'IN' },
						Length: u.length.toFixed(2),
						Width: u.width.toFixed(2),
						Height: u.height.toFixed(2),
					},
				};
				handlingUnits.push(hu);
			});

			//Request
			var rating_request = {
				ShipFrom: shipper,
				ShipperNumber: this.company.ups_shipper_number,
				ShipTo: ship_to,
				PaymentInformation: payment,
				Service: service,
				HandlingUnitOne: handling,
				//Commodity: commodity,
				Commodity: commodities,
				HandlingUnits: handlingUnits,
			};

			var request = { FreightRateRequest: rating_request };

			//console.log(this.compnay);
			// console.log(shipper);
			// console.log(ship_to);
			//console.log(request);
			//console.log(JSON.stringify(request));
			this.json_request = request;
			this.json_result = {};

			return JSON.stringify(request);
			//return JSON.stringify(rating_request);
		},
		makeUPSShipmentData() {
			//Shipper
			var shipper = {
				Name: this.company.name,
				Phone: {
					Number: this.company.phone_no ? this.company.phone_no.replace(/\D+/g, '') : '',
				},
				ShipperNumber: this.company.ups_shipper_number,
				// EmailAddress: 'kinznzl@janetcollection.com',
				EmailAddress: this.company.ups_email,
				Address: {
					AddressLine: this.company.ship_address_detail,
					City: this.company.ship_address_city,
					StateProvinceCode: this.company.ship_address_state,
					PostalCode: this.company.ship_address_zipcode,
					CountryCode: this.company.ship_address_country,
				},
			};

			if (!shipper.Address.CountryCode || shipper.Address.CountryCode == 'USA') shipper.Address.CountryCode = 'US';

			//Ship To
			if (this.shipment.ship_to_name.length > 35) {
				this.$toast.warning('Ship To Name exceeds 35 length. Excessive words will be truncated.');
			}

			if (this.shipment.address_detail && this.shipment.address_detail.length > 35) {
				this.$toast.warning('Ship To Address Line 1 exceeds 35 length. Excessive words will be truncated.');
			}

			if (this.shipment.address_detail2 && this.shipment.address_detail2.length > 35) {
				this.$toast.warning('Ship To Address Line 2 exceeds 35 length. Excessive words will be truncated.');
			}

			var ship_to = {
				Name: this.shipment.ship_to_name.substring(0, 35),
				Phone: {
					Number: this.shipment.telephone ? this.shipment.telephone.replace(/\D+/g, '') : '',
				},
				Address: {
					AddressLine: this.shipment.address_detail2 ? [this.shipment.address_detail.substring(0, 35), this.shipment.address_detail2.substring(0, 35)] : this.shipment.address_detail.substring(0, 35),
					City: this.shipment.address_city,
					StateProvinceCode: this.shipment.address_state,
					PostalCode: this.shipment.address_zipcode,
					CountryCode: this.shipment.address_country,
				},
			};

			if (!ship_to.Address.CountryCode || ship_to.Address.CountryCode == 'USA') ship_to.Address.CountryCode = 'US';

			//Service
			//var service = { Code: '03' };
			var service = { Code: this.shipment.service_code };

			//Packages
			var vm = this;
			var packages = [];
			if (this.service_type == 'F') {
				//this.commodities.forEach((c, index) => {
				this.commodities.forEach(c => {
					var com = {
						Description: c.description,
						//Description: 'International Goods',
						Packaging: {
							//Code: c.packaging_type == 'PLT' ? '30' : '02',
							Code: '02',
						},
						PackageWeight: {
							UnitOfMeasurement: { Code: 'LBS' },
							Weight: c.total_weight.toFixed(2),
						},
						PackageServiceOptions: {},
						Commodity: {
							FreightClass: '125',
							NMFC: {
								PrimeCode: '92120',
								SubCode: '1',
							},
						},
						// Dimensions: {
						// 	UnitOfMeasurement: { Code: 'IN' },
						// 	Length: vm.handling_units[index].length.toFixed(2),
						// 	Width: vm.handling_units[index].width.toFixed(2),
						// 	Height: vm.handling_units[index].height.toFixed(2),
						// },
					};

					if (vm.options.cod && c.cod_amount) {
						com.PackageServiceOptions.COD = {
							CODFundsCode: vm.options.cod_fund_code,
							CODAmount: {
								CurrencyCode: 'USD',
								MonetaryValue: c.cod_amount.toFixed(2),
							},
						};
					}

					if (c.hm_dg) {
						com.PackageServiceOptions.PackageIdentifier = {};
					}

					var freight_class;
					var prime_code;
					var sub_code;

					if (c.category == 'Hair') {
						freight_class = '125';
						prime_code = '92120';
						sub_code = '01';
					} else if (c.category == 'Brochures') {
						freight_class = '77.5';
						prime_code = '4860';
						sub_code = '02';
					} else if (c.category == 'Magazines') {
						freight_class = '70';
						prime_code = '161700';
						sub_code = '01';
					} else if (c.category == 'Mannequins') {
						freight_class = '250';
						prime_code = '75790';
						sub_code = '00';
					}

					if (c.category) {
						com.Commodity = {
							FreightClass: freight_class,
							NMFC: {
								PrimeCode: prime_code,
								SubCode: sub_code,
							},
						};
					}

					packages.push(com);
				});
			} else {
				this.boxes
					.filter(box => box.weight > 0)
					.forEach(b => {
						var com = {
							Packaging: {
								Code: '02',
							},
							PackageWeight: {
								UnitOfMeasurement: { Code: 'LBS' },
								Weight: b.weight.toFixed(2),
							},
							// PackageServiceOptions: b.hm_dg ? { PackageIdentifier: {} } : '',
							PackageServiceOptions: {},
							ReferenceNumber: [
								{
									//	Code: 'IK',
									Value: this.shipment.reference_no_1,
								},
								{
									//Code: 'TN',
									Value: this.shipment.reference_no_2,
								},
							],
						};
						if (b.length > 0 && b.width > 0 && b.height > 0)
							com.Dimensions = {
								UnitOfMeasurement: {
									Code: 'IN',
								},
								Length: b.length.toFixed(),
								Width: b.width.toFixed(),
								Height: b.height.toFixed(),
							};

						if (vm.options.cod && b.cod_amount) {
							com.PackageServiceOptions.COD = {
								CODFundsCode: vm.options.cod_fund_code,
								CODAmount: {
									CurrencyCode: 'USD',
									MonetaryValue: b.cod_amount.toFixed(2),
								},
							};
							// com.PackageServiceOptions = {
							// 	COD: {
							// 		CODFundsCode: vm.options.cod_fund_code,
							// 		CODAmount: {
							// 			CurrencyCode: 'USD',
							// 			MonetaryValue: b.cod_amount.toFixed(2),
							// 		},
							// 	},
							// };
						}

						if (vm.options.declared_value && b.declared_value) {
							com.PackageServiceOptions.DeclaredValue = {
								Type: {
									Code: vm.options.declared_value_code,
								},
								CurrencyCode: 'USD',
								MonetaryValue: b.declared_value.toFixed(2),
							};
						}

						if (b.hm_dg) {
							com.PackageServiceOptions.PackageIdentifier = {};
						}

						var freight_class;
						var prime_code;
						var sub_code;

						if (b.category == 'Hair') {
							freight_class = '125';
							prime_code = '92120';
							sub_code = '01';
						} else if (b.category == 'Brochures') {
							freight_class = '77.5';
							prime_code = '4860';
							sub_code = '02';
						} else if (b.category == 'Magazines') {
							freight_class = '70';
							prime_code = '161700';
							sub_code = '01';
						} else if (b.category == 'Mannequins') {
							freight_class = '250';
							prime_code = '75790';
							sub_code = '00';
						}

						if (b.category) {
							com.Commodity = {
								FreightClass: freight_class,
								NMFC: {
									PrimeCode: prime_code,
									SubCode: sub_code,
								},
							};
						}

						packages.push(com);
					});
			}

			//Reference Number
			// if (packages.length > 0) {
			// 	packages[0].ReferenceNumber = [
			// 		{ Code: 'IK', Value: 'BN12321' },
			// 		{ Code: 'TN', Value: 'SN12332121' },
			// 	];
			// }

			var ShipmentRatingOptions = {
				NegotiatedRatesIndicator: '',
			};

			var request = {
				ShipmentRequest: {
					Shipment: {
						Description: 'Hair Goods',
						//Description: 'Description Example',
						Shipper: shipper,
						ShipTo: ship_to,
						//PaymentInformation: payment,
						Service: service,
						//FRSPaymentInformation: frs_payment_information,
						// ReferenceNumber: {
						// 	Code: 'IK',
						// 	Value: this.invoice.invoice_dn,
						// },
						// ShipmentServiceOptions: {
						// 	Notification: {
						// 		NotificationCode: '6',
						// 		EMail: {
						// 			EMailAddress: 'gyjkim@pcohh.com',
						// 			//FromName: 'Beauty Plus',
						// 			//FromEMailAddress: 'gyjkim@gmail.com',
						// 		},
						// 	},
						// },
						Package: packages,
						ItemizedChargesRequestedIndicator: '',
						RatingMethodRequestedIndicator: '',
						TaxInformationIndicator: '',
						ShipmentRatingOptions: ShipmentRatingOptions,
					},
					LabelSpecification: {
						LabelImageFormat: {
							//Code: 'PNG',
							//Code: 'ZPL',
							Code: this.label_type,
						},
						LabelStockSize: {
							Height: '6',
							Width: '4',
						},
					},
				},
			};

			if (this.options.email) {
				request.ShipmentRequest.Shipment.ShipmentServiceOptions = {
					Notification: {
						NotificationCode: '6',
						EMail: {
							EMailAddress: this.partner.email_address,
							//FromName: 'Beauty Plus',
							//FromEMailAddress: 'gyjkim@gmail.com',
						},
					},
				};
			}

			// var freight_shipment_information = {

			// }

			//Payer
			// var payment = {
			// 	ShipmentCharge: {
			// 		Type: '01',
			// 		BillShipper: {
			// 			AccountNumber: this.company.ups_shipper_number,
			// 		},
			// 	},
			// };

			if (this.service_type == 'F') {
				request.ShipmentRequest.Shipment.ShipmentRatingOptions.FRSShipmentIndicator = '';
				request.ShipmentRequest.Shipment.FRSPaymentInformation = {
					Type: {
						Code: '01',
					},
					AccountNumber: this.company.ups_shipper_number,
					Address: {
						CountryCode: 'US',
					},
				};
			} else {
				// request.ShipmentRequest.Shipment.PaymentInformation = {
				// 	ShipmentCharge: {
				// 		Type: '01',
				// 		BillShipper: {
				// 			AccountNumber: this.company.ups_shipper_number,
				// 		},
				// 	},
				// };
				request.ShipmentRequest.Shipment.PaymentInformation = { ShipmentCharge: {} };
				request.ShipmentRequest.Shipment.PaymentInformation.ShipmentCharge.Type = '01';
				if (this.bill_transportation_to.type == 'S') {
					// request.ShipmentRequest.Shipment.PaymentInformation = {
					// 	ShipmentCharge: {
					// 		Type: '01',
					// 		BillShipper: {
					// 			AccountNumber: this.company.ups_shipper_number,
					// 		},
					// 	},
					// };
					request.ShipmentRequest.Shipment.PaymentInformation.ShipmentCharge.BillShipper = {
						AccountNumber: this.company.ups_shipper_number,
					};
				} else if (this.bill_transportation_to.type == 'R') {
					request.ShipmentRequest.Shipment.PaymentInformation.ShipmentCharge.BillReceiver = {
						AccountNumber: this.bill_transportation_to.account_number,
						Address: {
							PostalCode: this.bill_transportation_to.postal_code,
							CountryCode: this.bill_transportation_to.country_code,
						},
					};
				} else if (this.bill_transportation_to.type == 'T') {
					request.ShipmentRequest.Shipment.PaymentInformation.ShipmentCharge.BillThirdParty = {
						AccountNumber: this.bill_transportation_to.account_number,
						Address: {
							PostalCode: this.bill_transportation_to.postal_code,
							CountryCode: this.bill_transportation_to.country_code,
						},
					};
				}
			}

			// request.ShipmentRequest.Shipment.PaymentInformation.ShipmentCharge.Type = '01';

			//console.log(this.compnay);
			// console.log(shipper);
			// console.log(ship_to);
			//console.log(request);
			//console.log(JSON.stringify(request));

			this.json_request = request;
			this.json_result = {};

			return JSON.stringify(request);
			//return JSON.stringify(rating_request);
		},
		makeFedexShipmentData() {
			//var total_cod_amount = 0;
			var total_declared_value = 0;
			var packages = [];
			var vm = this;
			this.boxes.forEach(b => {
				//if (b.cod_amount) total_cod_amount += b.cod_amount;
				if (b.declared_value) total_declared_value += b.declared_value;

				var box = {
					customerReferences: [
						{
							customerReferenceType: 'INVOICE_NUMBER',
							value: this.shipment.reference_no_1,
						},
						{
							customerReferenceType: 'CUSTOMER_REFERENCE',
							value: this.shipment.reference_no_2,
						},
					],
					weight: {
						units: 'LB',
						value: b.weight.toFixed(2),
					},
				};

				if (vm.options.declared_value && b.declared_value) {
					box.declaredValue = {
						amount: b.declared_value.toFixed(2),
						currency: 'USD',
					};
				}

				packages.push(box);
			});

			var streetLines = [this.shipment.address_detail.substring(0, 35)];
			if (this.shipment.address_detail2) streetLines.push(this.shipment.address_detail2.substring(0, 35));

			var request = {
				requestedShipment: {
					shipper: {
						address: {
							streetLines: [this.company.ship_address_detail],
							city: this.company.ship_address_city,
							stateOrProvinceCode: this.company.ship_address_state,
							postalCode: this.company.ship_address_zipcode,
							countryCode: this.company.ship_address_country,
						},
						contact: {
							companyName: this.company.name,
							phoneNumber: this.company.phone_no ? this.company.phone_no.replace(/\D+/g, '') : '',
						},
					},
					recipients: [
						{
							address: {
								//streetLines: [this.shipment.address_detail.substring(0, 35), this.shipment.address_detail2.substring(0, 35)],
								streetLines: streetLines,
								city: this.shipment.address_city,
								stateOrProvinceCode: this.shipment.address_state,
								postalCode: this.shipment.address_zipcode,
								countryCode: this.shipment.address_country,
							},
							contact: {
								companyName: this.shipment.ship_to_name.substring(0, 35),
								phoneNumber: this.shipment.telephone ? this.shipment.telephone.replace(/\D+/g, '') : '',
							},
						},
					],
					pickupType: 'USE_SCHEDULED_PICKUP',
					serviceType: 'FEDEX_GROUND',
					packagingType: 'YOUR_PACKAGING',
					shippingChargesPayment: {
						paymentType: 'SENDER',
					},
					// shipmentSpecialServices: {
					// 	specialServiceTypes: [],
					// },
					requestedPackageLineItems: packages,
					labelSpecification: {
						//labelStockType: 'PAPER_4X6',
						//imageType: 'PNG',
						//labelStockType: 'STOCK_4X6',
						labelStockType: 'STOCK_4X675_LEADING_DOC_TAB',
						//imageType: 'ZPLII',
						imageType: this.label_type == 'ZPL' ? 'ZPLII' : 'PNG',
					},
				},
				labelResponseOptions: 'LABEL',
				accountNumber: {
					value: this.company.fedex_account_number,
				},
				//shipAction: 'CONFIRM',
			};

			if (!request.requestedShipment.shipper.address.countryCode || request.requestedShipment.shipper.address.countryCode == 'USA') request.requestedShipment.shipper.address.countryCode = 'US';
			if (!request.requestedShipment.recipients[0].address.countryCode || request.requestedShipment.recipients[0].address.countryCode == 'USA') request.requestedShipment.recipients[0].address.countryCode = 'US';

			if (this.bill_transportation_to.type != 'S') {
				request.requestedShipment.shippingChargesPayment.paymentType = this.bill_transportation_to.type == 'R' ? 'RECIPIENT' : 'THIRD_PARTY';
				request.requestedShipment.shippingChargesPayment.payer = {
					responsibleParty: {
						accountNumber: {
							value: this.bill_transportation_to.account_number,
						},
					},
				};
			}

			if (this.boxes.length > 40) {
				request.processingOptionType = 'ALLOW_ASYNCHRONOUS';
				this.shipment.async = true;
			}

			/*
			if (this.options.cod) {
				request.requestedShipment.shipmentSpecialServices = {
					specialServiceTypes: ['COD'],
				};
				//request.requestedShipment.shipmentSpecialServices.specialServiceTypes.push('COD');
				request.requestedShipment.shipmentSpecialServices.shipmentCODDetail = {
					codCollectionType: 'ANY',
					shipmentCodAmount: {
						amount: total_cod_amount.toFixed(2),
						currency: 'USD',
					},
				};
			} */

			//shipmentCodAmount
			//codCollectionAmount

			if (this.options.declared_value) {
				request.requestedShipment.totalDeclaredValue = total_declared_value;
			}

			if (this.options.email) {
				request.requestedShipment.emailNotificationDetail = {
					aggregationType: 'PER_SHIPMENT',
					emailNotificationRecipients: [
						{
							emailNotificationRecipientType: 'RECIPIENT',
							emailAddress: this.partner.email_address,
						},
					],
				};
			}

			this.json_request = request;
			this.json_result = {};

			//console.log(JSON.stringify(request, null, 2));
			return JSON.stringify(request);
		},
		makeJsonData() {
			if (!this.options.cod)
				this.boxes.forEach(b => {
					b.cod_amount = null;
				});

			return JSON.stringify({
				boxes: this.boxes,
				commodities: this.commodities,
				handling_units: this.handling_units,
				bill_transportation_to: this.bill_transportation_to,
				options: this.options,
				reference_no_1: this.shipment.reference_no_1,
				reference_no_2: this.shipment.reference_no_2,
			});
		},
		close() {
			//console.log('closing');
			var to_apply_charge = this.shipment.total_charge;
			if ((this.user.company_id == 'he' || this.user.company_id == 'newjigu') && this.shipment.nego_charge > 0) to_apply_charge = this.shipment.nego_charge;
			//this.$emit('closeWithReturn', this.shipment.total_charge);
			this.$emit('closeWithReturn', to_apply_charge);
			this.$emit('close');
		},
		async save() {
			//console.log('save');
			// if (!this.receipt_date || !isDate(this.receipt_date)) {
			// 	this.$toast.error('Invalid receipt date');
			// 	return;
			// }
			// if (this.amountTotal != this.totalReceiptAmount) {
			// 	this.$toast.error('Amounts do not match.');
			// 	return;
			// }
			// if (this.receipt_methods.filter(method => method.post_check_yn == 'Y').length > 1) {
			// 	this.$toast.error('Only one post check is allowed for one payment.');
			// 	return;
			// }

			// if (this.receipt_methods.filter(method => method.post_check_yn == 'Y').length > 0 && this.receipt_methods.length > 1) {
			// 	this.$toast.error('Post check is not allowed with other payment methods.');
			// 	return;
			// }

			// var con = true;
			// var vm = this;
			// var valid_receipt_date = this.receipt_date;

			// this.receipt_methods.forEach(function(method) {
			// 	if (method.post_check_yn == 'Y' && (!method.post_check_date || !isDate(method.post_check_date))) {
			// 		vm.$toast.error('Invalid post check date');
			// 		con = false;
			// 	} else if (method.post_check_yn == 'Y') valid_receipt_date = method.post_check_date;

			// 	if (method.receipt_type.name.toUpperCase().indexOf('CHECK') >= 0 && !method.check_no) {
			// 		vm.$toast.error('Some check no is empty.');
			// 		con = false;
			// 	}
			// });
			// if (!con) return;

			// //console.log(this.receipt_methods);
			this.shipment.json_content = this.makeJsonData();

			if (this.user.company_id == 'minkhair') this.shipment.update_invoice_value = true;

			if (this.options.cod) this.shipment.cod_amount = this.getTotalCodAmount();
			else this.shipment.cod_amount = null;

			const { data } = await apiUpdateInvoiceShipment(this.shipment);

			if (data.result) {
				this.$toast.success('Saved successfully', { duration: 1000, pauseOnHover: false });
				// this.$emit('receipt-call-back', true);
				// this.close();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async checkLabelExists() {
			const { data } = await apiSelectInvoiceShipment({ invoice_no: this.invoice ? this.invoice.invoice_no : this.invoice_no, for_shipment: true });

			if (data.shipmentBoxList.length > 0) return true;
			else return false;
		},
		async selectInvoiceShipment() {
			const { data } = await apiSelectInvoiceShipment({ invoice_no: this.invoice ? this.invoice.invoice_no : this.invoice_no, for_shipment: true });
			//console.log(data);
			this.additionalInvoices = data.additionalInvoices;
			this.partner = data.partner;
			//console.log(this.partner);
			this.partner.email_address = this.partner.email ? this.partner.email : this.partner.email2;
			//console.log(this.partner);
			this.shipment = data.shipment;
			this.histories = data.shipmentHistory;
			//console.log(this.history);

			var changes = data.deliveryChangeHistory;
			//console.log(changes);
			if (this.user.company_id == 'beautyplus' && changes.length > 1 && changes[0].toUpperCase().includes('UPS')) {
				if (changes[1].toUpperCase().includes('DELIVERY')) this.deliveryChangeMessage = 'Delivery -> UPS';
				else if (changes[1].toUpperCase().includes('PICKUP')) this.deliveryChangeMessage = 'Pick Up -> UPS';
				else if (changes[1].toUpperCase().includes('FEDEX')) this.deliveryChangeMessage = 'Fedex -> UPS';
			}
			//console.log(this.user.company_id, this.invoice.delivery_type_code, this.shipment.courier_type);

			let shipChanges = data.shipChangeHistory;
			if (this.user.company_id === 'beautyplus' && shipChanges.length > 1) {
				this.shipToChangeMessage = shipChanges[1] + ' -> ' + shipChanges[0];
			}

			if (this.user.company_id == 'beautyplus' || this.user.company_id == 'hairplus') {
				// && !this.shipment.courier_type) {
				if ((this.user.company_id == 'beautyplus' && this.invoice.delivery_type_code == 'T001') || (this.user.company_id == 'hairplus' && this.invoice.delivery_type_code == 'T01')) {
					if (!this.shipment.courier_type) this.shipment.courier_type = 'U';
					this.service_type = 'G';
				} else if (this.invoice.delivery_type_code == 'T15') {
					if (!this.shipment.courier_type) this.shipment.courier_type = 'U';
					this.service_type = 'F';
				} else if (this.invoice.delivery_type_code == 'T11') {
					if (!this.shipment.courier_type) this.shipment.courier_type = 'F';
					this.service_type = 'G';
				}
			} else if (this.user.company_id == 'newjigu') {
				if (this.invoice.delivery_type_code == 'UG') {
					this.shipment.courier_type = 'U';
					this.service_type = 'G';
				} else if (this.invoice.delivery_type_code == 'FG') {
					this.shipment.courier_type = 'F';
					this.service_type = 'G';
				} else if (this.invoice.delivery_type_code == 'ND') {
					this.shipment.courier_type = 'U';
					this.service_type = 'G';
					this.shipment.service_code = '01';
				} else if (this.invoice.delivery_type_code == '2D') {
					this.shipment.courier_type = 'U';
					this.service_type = 'G';
					this.shipment.service_code = '02';
				}
			} else {
				this.shipment.courier_type = 'U';
				this.service_type = 'G';
			}

			//console.log(this.service_type);

			var json_content = JSON.parse(this.shipment.json_content);
			if (json_content) {
				//console.log(json_content);

				this.commodities = json_content.commodities;
				this.handling_units = json_content.handling_units;
				this.bill_transportation_to = json_content.bill_transportation_to;
				if (json_content.options) this.options = json_content.options;
			}

			if (!('email' in this.options) && this.partner.email_address) this.options.email = true;

			if (!this.bill_transportation_to || !this.bill_transportation_to.type) this.bill_transportation_to = { type: 'S' };

			this.countries = data.countryList;
			this.shipmentBoxes = data.shipmentBoxList;
			this.packing_boxes = data.boxList;

			if (this.shipmentBoxes.length > 0) this.label_exists = true;
			else this.label_exists = false;

			if (json_content && json_content.boxes) this.boxes = json_content.boxes;
			else if (!this.label_exists) this.boxes = this.packing_boxes;

			if (json_content && json_content.reference_no_1) this.shipment.reference_no_1 = json_content.reference_no_1;
			else if (!this.label_exists) {
				if (this.user.company_id == 'minkhair') this.shipment.reference_no_1 = this.invoice.invoice_dn + ' ' + this.invoice.ship_to_name;
				else this.shipment.reference_no_1 = this.invoice.ship_to_code + ' ' + this.invoice.invoice_dn;
			}

			if (json_content && json_content.reference_no_2) this.shipment.reference_no_2 = json_content.reference_no_2;
			else if (!this.label_exists) this.shipment.reference_no_2 = this.invoice.so_dn;

			//if (this.shipment.courier_type == 'U' && !this.shipment.service_code) this.shipment.service_code = '03';
			if (!this.shipment.service_code) this.shipment.service_code = '03';

			//console.log(this.boxes);

			if (!this.label_exists && !json_content) {
				this.setDefaultCategory();
				// if (this.options.cod && this.boxes.length > 0 && !this.codExists()) {
				// 	this.setCodAndDeclaredValue();
				if (this.boxes.length > 0) {
					this.setDeclaredValue();
					if (this.options.cod && !this.codExists()) this.setCod();
				}
			}

			//console.log(this.shipment);
			//console.log(this.shipmentBoxes);
			//console.log(this.boxes);
			//console.log(this.user.company_id, this.invoice.delivery_type_code, this.shipment.courier_type);
		},
		setDefaultCategory() {
			if (this.user.company_id != 'he') {
				this.boxes.forEach(b => {
					if (!b.category) b.category = 'Hair';
				});

				this.commodities.forEach(c => {
					if (!c.category) c.category = 'Hair';
				});
			}
		},
		setCod() {
			//console.log(this.invoice);
			if (this.user.company_id == 'beautyplus') this.boxes[this.getMostExpensiveBoxIndex(false)].cod_amount = this.invoice.balance;
			else if (this.user.company_id == 'hairplus') this.boxes[this.getMostExpensiveBoxIndex(true)].cod_amount = this.invoice.balance;
			else this.boxes[0].cod_amount = this.invoice.balance;

			this.boxes.forEach(b => {
				b.cod_apply = true;
			});
		},
		setDeclaredValue() {
			if (this.user.company_id == 'hairplus') {
				for (var i = 0; i < this.boxes.length; i++) {
					//console.log(this.boxes[i]);
					if (this.boxes[i].amount > 1300) {
						this.options.declared_value = true;
						this.boxes[i].declared_value = this.boxes[i].amount * 0.85;
					}
				}
			} else {
				this.options.declared_value = false;
			}
		},
		loadDefaultReferenceNos() {
			//console.log('test');
			if (this.user.company_id == 'minkhair') this.shipment.reference_no_1 = this.invoice.invoice_dn + ' ' + this.invoice.ship_to_name;
			else this.shipment.reference_no_1 = this.invoice.ship_to_code + ' ' + this.invoice.invoice_dn;

			this.shipment.reference_no_2 = this.invoice.so_dn;

			this.$forceUpdate();
		},
		initialize() {
			this.boxes = this.packing_boxes;
			//console.log(this.boxes);

			for (var i = 0; i < this.boxes.length; i++) {
				this.boxes[i].cod_amount = null;
			}

			//if (!this.label_exists && this.options.cod && this.boxes.length > 0) {
			//this.setCodAndDeclaredValue();
			//if (!this.label_exists && this.boxes.length > 0) {
			if (this.boxes.length > 0) {
				this.setDeclaredValue();
				this.setDefaultCategory();
				if (this.options.cod) this.setCod();
			}
		},
		codExists() {
			// for (var i = 0; i < this.boxes.length; i++) {
			// 	if (this.boxes[i].cod_amount > 0) return true;
			// }
			if (this.boxes.filter(b => b.cod_amount > 0).length > 0) return true;
			return false;
		},
		getHeaviestBoxIndex() {
			var hi = 0;
			var currentWeight = 0;

			//console.log(this.boxes);

			for (var i = 0; i < this.boxes.length; i++) {
				if (this.boxes[i].weight > currentWeight) {
					hi = i;
					currentWeight = this.boxes[i].weight;
				}
			}

			return hi;
		},
		getMostExpensiveBoxIndex(with_no_declared_value) {
			var hi = 0;
			var currentAmount = 0;

			//console.log(this.boxes);

			for (var i = 0; i < this.boxes.length; i++) {
				if (this.boxes[i].amount > currentAmount && (!with_no_declared_value || !(this.boxes[i].declared_value > 0))) {
					hi = i;
					currentAmount = this.boxes[i].amount;
				}
			}

			return hi;
		},
		getZPLCommands() {
			var zpl = '';
			this.shipmentBoxes.forEach(b => {
				zpl += atob(b.label_image_data);
			});
			return zpl;
		},
		async upsLabelPrint() {
			if (this.shipmentBoxes.length > 0) {
				var image_type = this.shipmentBoxes[0].label_image_type;
				if (image_type.startsWith('ZPL')) {
					zplPrint(this.getZPLCommands());
					//console.log(zpl);
				} else if (image_type == 'PNG') {
					const reportTemplate = await apiGetBase64ReportTemplate('upsLabel', reportMrtUrl('upsLabel'));
					const report = new Report(reportTemplate, this.printData, 'upsLabel');
					this.$store.commit('setReport', report);
				}

				await this.insertShipmentLabelPrintHistory(this.shipment);
			}
		},
		async fedexLabelPrint() {
			if (this.shipmentBoxes.length > 0) {
				var image_type = this.shipmentBoxes[0].label_image_type;
				if (image_type.startsWith('ZPL')) {
					zplPrint(this.getZPLCommands());
					//console.log(zpl);
				} else if (image_type == 'PNG') {
					const reportTemplate = await apiGetBase64ReportTemplate('fedexLabel', reportMrtUrl('fedexLabel'));
					const report = new Report(reportTemplate, this.printData, 'fedexLabel');
					this.$store.commit('setReport', report);
				}

				await this.insertShipmentLabelPrintHistory(this.shipment);
			}
		},
		async printFedexAcctChangeLabel() {
			const reportTemplate = await apiGetReportTemplate('ShipToChangeMessage', reportMrtUrl('ShipToChangeMessage'));
			const report = new Report(reportTemplate, { shipToChangeMessage: this.shipToChangeMessage }, 'fedex_accounts_change_label');
			this.$store.commit('setReport', report);
		},
		async insertShipmentLabelPrintHistory() {
			apiInsertShipmentLabelPrintHistory(this.shipment)
				.then(() => apiSelectInvoiceShipmentHistory(this.invoice ? this.invoice.invoice_no : this.invoice_no))
				.then(({ data }) => (this.histories = data));
		},
	},
	created() {
		if (this.$session.get('profile').label_type) this.label_type = this.$session.get('profile').label_type;
		else this.label_type = 'PNG';

		this.selectInvoiceShipment();
		//console.log(this.invoice.payment_term_name);
		if (this.invoice.payment_term_name && this.invoice.payment_term_name.indexOf('COD') >= 0) {
			this.options.cod = true;
			if (this.invoice.payment_term_name.indexOf('M/O') >= 0) {
				this.options.cod_fund_code = '8';
			}
		}
		// this.$nextTick(() => {
		// 	this.$forceUpdate();
		// });
		//console.log(this.invoice);
		//this.search();
		//console.log(this.totalReceiptAmount, this.toReceiveInvoices);
	},
	mounted() {
		var vm = this;

		window.addEventListener('keyup', function(ev) {
			//self.myMethod(ev); // declared in your component methods
			if (ev.code == 'Escape') vm.close();
		});
	},
};
</script>

<style></style>
